import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError, of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private apiUrl = `${environment.apiUrl}/auth`; // sin "/" final
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;

  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<any>(null);
    this.currentUser = this.currentUserSubject.asObservable();
  }

   /** 🔑 Llamar al backend para autenticar y obtener perfil */
  login(email: string, password: string): Observable<any> {
    const body = { email, password };
    return this.http.post(`${this.apiUrl}/login`, body, { withCredentials: true }).pipe(
      tap(() => this.loadProfile().subscribe()),
      catchError(err => {
        console.error('Error en login', err);
        throw err;
      })
    );
  }

   /** 📄 Obtener perfil del backend (usa cookie segura) */
  loadProfile(): Observable<any> {
    return this.http.get(`${this.apiUrl}/profile`, { withCredentials: true }).pipe(
      tap((resp: any) => {
        this.currentUserSubject.next(resp.usuario);
        sessionStorage.setItem('usuario', JSON.stringify(resp.usuario));
      }),
      catchError(err => {
        console.error('Error cargando perfil', err);
        this.currentUserSubject.next(null);
        return of(null);
      })
    );
  }
  // 👤 OBTENER PERFIL (usando cookie JWT)
  getProfile(): Observable<any> {
    return this.http.get(`${this.apiUrl}/profile`, { withCredentials: true }).pipe(
      tap((resp: any) => {
        this.currentUserSubject.next(resp.usuario);
        sessionStorage.setItem('usuario', JSON.stringify(resp.usuario));
      }),
      catchError(error => throwError(() => error))
    );
  }

  logout(): Observable<any> {
    return this.http.post(`${this.apiUrl}/logout`, {}, { withCredentials: true }).pipe(
      tap(() => this.clearLocalState()),
      catchError(error => throwError(() => error))
    );
  }

 /*  getProfile(): Observable<any> {
    return this.http.get(`${this.apiUrl}/profile`, { withCredentials: true });
  } */

  getCurrentUser(): Observable<any> {
    return this.currentUser;
  }

  getCurrentUserValue(): any {
    return this.currentUserSubject.value;
  }

  isAuthenticated(): boolean {
    return !!this.currentUserSubject.value;
  }

  // ✅ Método para limpiar solo el estado local sin llamar al backend
  clearLocalState(): void {
    this.currentUserSubject.next(null);
    // Puedes limpiar localStorage/sessionStorage si usas
  }
  

  initUser(): void {
  this.getProfile().subscribe({
    next: user => this.currentUserSubject.next(user),
    error: () => this.clearLocalState() // si cookie expira o no hay sesión
  });
}

// ----------------------------------------------------------------
  // 🧠 CONTROL DE ROLES Y PERMISOS
  // ----------------------------------------------------------------

  /** ✅ Verifica si el usuario tiene un permiso específico */
  hasPermiso(permiso: string): boolean {
    const usuario = this.usuarioActual;
    if (!usuario || !usuario.permisos) return false;
    return usuario.permisos.includes(permiso);
  }

  /** ✅ Verifica si el usuario tiene un rol */
  hasRol(rol: string): boolean {
    const usuario = this.usuarioActual;
    if (!usuario || !usuario.roles) return false;
    return usuario.roles.includes(rol);
  }

  /** 🧾 Obtener todos los permisos */
  getPermisos(): string[] {
    return this.usuarioActual?.permisos || [];
  }

  /** 🧾 Obtener todos los roles */
  getRoles(): string[] {
    return this.usuarioActual?.roles || [];
  }

  /** Getter para obtener el usuario actual */
  get usuarioActual(): any {
    return this.getCurrentUserValue();
  }
}
